<template>
  <div id="beyond">
    <div class="loader">
      <span :style="{ background: $util.barColor(grade) }"></span>
      <span :style="{ background: $util.barColor(grade) }"></span>
      <span :style="{ background: $util.barColor(grade) }"></span>
      <span :style="{ background: $util.barColor(grade) }"></span>
      <span :style="{ background: $util.barColor(grade) }"></span>
      <span :style="{ background: $util.barColor(grade) }"></span>
      <span :style="{ background: $util.barColor(grade) }"></span>
      <span :style="{ background: $util.barColor(grade) }"></span>
      <span :style="{ background: $util.barColor(grade) }"></span>
      <span :style="{ background: $util.barColor(grade) }"></span>
    </div>
  </div>
</template>
<script>
// import util from "@/config/color";
export default {
  name: "Beyond",
  props: {
    grade: {},
    beyond: {
      type: Number,
      default: 1
    },
    beyondIndex: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      // util:util,
      keyframesList: [
        "10%{ bottom: calc(1*7%); left: calc(0*10.4%); }",
        "15%{bottom: calc((1*7%) + 20%);}",
        "20%{bottom: calc(2*7%);left: calc(1*10.4%);}",
        "25%{bottom: calc((2*7%) + 20%);}",
        "30%{bottom: calc(3*7%);left: calc(2*10.4%);}",
        "35%{bottom: calc((3*7%) + 20%);}",
        "40%{bottom: calc(4*7%);left: calc(3*10.4%);}",
        "45%{bottom: calc((4*7%) + 20%);}",
        "50%{bottom: calc(5*7%);left: calc(4*10.4%);}",
        "55%{bottom: calc((5*7%) + 20%);}",
        "60%{bottom: calc(6*7%);left: calc(5*10.4%);}",
        "65%{bottom: calc((6*7%) + 20%);}",
        "70%{bottom: calc(7*7%);left: calc(6*10.4%);}",
        "75%{bottom: calc((7*7%) + 20%);}",
        "80%{bottom: calc(8*7%);left: calc(7*10.4%);}",
        "85%{bottom: calc((8*7%) + 20%);}",
        "90%{bottom: calc(9*7%);left: calc(8*10.4%);}",
        "95%{bottom: calc((9*7%) + 20%);}",
        "100%{bottom: calc(var(--number)*7%);left: calc((var(--number) - 1)*10.4%);}"
      ],
      keyframesStyle: ""
    };
  },
  created() {
    this.createKeyFrames(this.beyondIndex);
    this.addKeyFrames();
  },
  methods: {
    createKeyFrames(beyond) {
      console.log(beyond);
      if (beyond > 1) {
        let str = "";
        switch (beyond) {
          case 2:
            for (let i = 0; i <= 2; i++) {
              str += this.keyframesList[i];
            }
            break;
          case 3:
            for (let i = 0; i <= 4; i++) {
              str += this.keyframesList[i];
            }
            break;
          case 4:
            for (let i = 0; i <= 6; i++) {
              str += this.keyframesList[i];
            }
            break;
          case 5:
            for (let i = 0; i <= 8; i++) {
              str += this.keyframesList[i];
            }
            break;
          case 6:
            for (let i = 0; i <= 10; i++) {
              str += this.keyframesList[i];
            }
            break;
          case 7:
            for (let i = 0; i <= 12; i++) {
              str += this.keyframesList[i];
            }
            break;
          case 8:
            for (let i = 0; i <= 14; i++) {
              str += this.keyframesList[i];
            }
            break;
          case 9:
            for (let i = 0; i <= 16; i++) {
              str += this.keyframesList[i];
            }
            break;
          case 10:
            for (let i = 0; i <= 17; i++) {
              str += this.keyframesList[i];
            }
            break;
        }
        this.keyframesStyle = str;
      }
    },
    addKeyFrames() {
      let style = document.createElement("style");
      style.innerHTML =
        "@keyframes climbing{" +
        "0%{bottom: 7%;left: 0;}" +
        this.keyframesStyle +
        "100%{bottom: calc(" +
        this.beyondIndex +
        "*7%);left: calc((" +
        this.beyondIndex +
        " - 1)*10.4%);}";
      ("}");
      document.getElementsByTagName("head")[0].appendChild(style);
    }
  }
};
</script>
<style lang="scss" scoped>
#beyond {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  --number: 2;
  .loader {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    span {
      width: 6.4%;
      height: 7%;
      background: linear-gradient(180deg, #f9bc0b, #fba22e 10%);
      animation: sort 1s ease-in-out;
    }
    span {
      height: calc(var(--n) * 7%);
    }
    span:nth-child(1) {
      --n: 1;
    }
    span:nth-child(2) {
      --n: 2;
    }
    span:nth-child(3) {
      --n: 3;
    }
    span:nth-child(4) {
      --n: 4;
    }
    span:nth-child(5) {
      --n: 5;
    }
    span:nth-child(6) {
      --n: 6;
    }
    span:nth-child(7) {
      --n: 7;
    }
    span:nth-child(8) {
      --n: 8;
    }
    span:nth-child(9) {
      --n: 9;
    }
    span:nth-child(10) {
      --n: 10;
    }
    @keyframes sort {
      0% {
        width: 0;
        height: 0;
      }
      100% {
        height: calc(var(--n) * 7%);
      }
    }
  }
  .loader::before {
    content: "";
    background: url("https://eaas-cdn.risecenter.com/level-card-child.png")
      no-repeat;
    background-size: 100%;
    position: absolute;
    width: 6.4%;
    height: 36%;
    bottom: 7%;
    left: 0;
    animation: climbing 3s linear;
    animation-fill-mode: forwards;
    animation-delay: 1.5s;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/Beyond.vue